import Reveal from './Reveal';
import { FaXmark } from 'react-icons/fa6';
import { useOverlay } from '../providers/OverlayProvider';
import { motion } from 'framer-motion';

function Overlay() {
  const { overlay, setOverlay } = useOverlay();

  function handleCloseOverlay() {
    setOverlay(null);
  }

  return overlay && (
    <div className="overlay">
      <Reveal className="content" delay={0} duration={0.35} move={false}>
        {overlay}
      </Reveal>
      <div className="close">
        <motion.button whileHover={{scale: 0.95}} onClick={handleCloseOverlay}>
          <FaXmark className="icon" />
        </motion.button>
      </div>
    </div>
  );
}

export default Overlay;